import * as React from 'react';

import { Store } from '../stores';
import { IComposerButton } from '../../../interfaces/IComposerButton';
import { inject, observer } from 'mobx-react';
import { IAButton } from '../../button/Button';
import * as styles from './Button.css';
import { Controller } from '../controller/Controller';
import { LocalizationService } from '../../../services/LocalizationService';

export interface IProps {
  store?: Store;
  id: string;
  button: IComposerButton;
  index?: number;
  hideToolbox: boolean;
  showDropZones: boolean;
  isInMobileToolbox?: boolean;
  fontFamily?: string;
  onFocus?: () => void;
  onChange: (button: IComposerButton) => void;
  onDrag?: () => void;
  onDragEnd?: () => void;
}

export interface IState {

  showController: boolean;
  dragging: boolean;
  showDropZones: boolean;
}

@inject('store')
@observer
export class Button extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      dragging: false,
      showController: this.props.isInMobileToolbox ? true : false,
      showDropZones: false
    };

    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.hideToolbox) {
      this.hideToolbox();
    }
    if (props.showDropZones) {
      this.hideToolbox()
    }
    if (this.props.hideToolbox !== props.hideToolbox && props.hideToolbox != undefined && !props.hideToolbox) {
      this.setState({ showController: true });
    }
    if (props.showDropZones !== this.props.showDropZones) {
      setTimeout(() => {
        this.setState({ showDropZones: props.showDropZones });
      }, 0);
    }
  }

  private showToolbox(): void {
    this.setState({ showController: true });
    this.forceUpdate();
  }

  private buttonOnClick(): void {
    setTimeout(() => {
      this.props.onFocus();
      this.showToolbox();


    }, 100);
  }

  private hideToolbox(): void {
    this.setState({ showController: false });
    this.forceUpdate();
  }

  public render(): JSX.Element {


    let showController = this.state.showController && !this.state.showDropZones;
    if (showController && !this.props.store.activeComponent?.button) showController = false;

    let label = this.props.button.text ?? "...";

    return (


      <div key={this.props.id} id={"IA_Button"} className={styles.IA_ButtonContainer} style={{ "justifyContent": this.props.button.align }}>


        {((this.props.store.isMobile && this.props.isInMobileToolbox) || !this.props.store.isMobile) &&
          <Controller
            visible={showController}
            highlightColor={this.props.store.highlightColor}
            onDublicate={!this.props.isInMobileToolbox ? () => this.props.store.dublicateComponent() : undefined}
            onDelete={() => {
              if (this.props.store.activeComponent.button) {

                this.props.store.removeComponentAtIndex(this.props.index);
                this.hideToolbox()
                this.props.store.activeComponent = undefined;

              }
              this.forceUpdate();
            }}
            onDrag={this.props.onDrag ? () => this.props.onDrag() : undefined}
            onDragEnd={this.props.onDragEnd ? () => this.props.onDragEnd() : undefined}
          />
        }
        {this.state.showDropZones && this.props.index === 0 && !this.state.showController &&
          <div
            style={{
              marginBottom: 10
            }}
            className={styles.IA_dropZones}
            onDragOver={(event) => {
              event.preventDefault();
            }}
            onDragEnter={(event) => {
              event.preventDefault();
            }}
            onDropCapture={(event) => {
              event.preventDefault();
              if (this.props.store.startIndex != undefined) {
                this.props.store.moveComponentAtIndex(0);
              } else {
                this.props.store.addComponentAtIndex(0);
              }
            }}
          />
        }

        <IAButton label={label}
          textColor={this.props.button.textColor}
          buttonColor={this.props.button.backgroundColor}
          borderRadius={this.props.button.borderRadius}
          fontSize={this.props.button.textSize}
          height={this.props.button.textSize * 2.5}
          fontFamily={this.props.fontFamily}
          onClick={() =>
            this.buttonOnClick()

          }
        >
        </IAButton>
      </div>
    )

  }
}